import React from 'react';
import './style.css';

export class Contact extends React.Component {
    render() {
        return (
            <div id="contact-screen">
                <div className="contact-upper-container">
                    <div className="contact-upper-content">SOLLTET IHR WEITERE FRAGEN HABEN, MELDET EUCH GERNE BEI UNS!</div>
                </div>
                <div className="contact-lower-container">
                    <div className="contact-lower-content">ODER BEI UNSEREN TRAUZEUGEN</div>
                    <div className="contact-bestmans-container">
                        <div className="contact-lower-maidofhonor">LAURA VETTER</div>
                        <div className="contact-lower-contact">+49 1578 2291421</div>
                    </div>
                    <div className="contact-bestmans-container">
                        <div className="contact-lower-bestman">SIMON HALBGEWACHS</div>
                        <div className="contact-lower-contact">+49 176 24941516</div>
                    </div>
                </div>
            </div>
        );
    }
}
